// extracted by mini-css-extract-plugin
export default {"comingsoon-container":"splash-screen_comingsoon-container__YPKMa","gto-label__color":"splash-screen_gto-label__color__+aVjz"};